import React from 'react';
import { Nav, Divider, Tag, Switch } from '@douyinfe/semi-ui';
import { 
    IconBookStroked, 
    IconLineChartStroked, 
    IconPieChartStroked, 
    IconPieChart2Stroked, 
    IconCodeStroked, 
    IconUserStroked, 
    IconSettingStroked,
    IconConfigStroked,
    IconBriefStroked,
    IconBookOpenStroked,
    IconWindowAdaptionStroked,
    IconFlowChartStroked,
    IconLoopTextStroked,
    IconUserListStroked,
    IconTestScoreStroked,
    IconPlusStroked,
    IconServerStroked,
    IconCloudUploadStroked,
    IconCandlestickChartStroked, 
    IconSendMsgStroked,
    IconSmartphoneStroked,
    IconComponentPlaceholderStroked,
    IconBarChartVStroked,
    IconGridStroked,
    IconSearch,
    IconBulb,
    IconBox
} from '@douyinfe/semi-icons';
import { isNull } from 'lodash';

import LoginButton from '../Login/LoginButton';
import MaintanceModeButton from '../UI/MaintanceModeButton';

import config from '../../config';

const menu = [
    { itemKey: 'dashboard', text: 'Статистика', link: '/dashboard', icon: <IconPieChartStroked /> },
    { itemKey: 'profile', text: 'Профиль', link: '/profile', icon: <IconUserStroked /> },
    { 
        itemKey: 'documents', 
        text: 'Документы', 
        icon: <IconBriefStroked />,
        items: [
            {
                itemKey: 'procurement',
                text: 'Поступления',
                link: '/docs/procurement',
                icon: <IconBriefStroked/>
            },
            {
                itemKey: 'sales', 
                text: 'Продажи', 
                link: '/docs/sales',
                icon: <IconBriefStroked />, 
            },
            {
                itemKey: 'sfout',
                text: 'СФ исходящие',
                link: '/docs/sf/outgoing',
                icon: <IconBriefStroked/>
            },
            {
                itemKey: 'sfin',
                text: 'СФ входящие',
                link: '/docs/sf/incoming',
                icon: <IconBriefStroked/>
            },
            {
                itemKey: 'salary',
                text: 'Зарплата',
                link: '/docs/salary',
                icon: <IconBriefStroked/>
            }            
        ]
    },
    { 
        itemKey: 'sprav', 
        text: 'Справочники', 
        icon: <IconBookOpenStroked />,
        items: [
            {
                itemKey: 'org',
                text: 'Организации',
                link: '/sprav/org',
                icon: <IconBookOpenStroked/>
            },
            {
                itemKey: 'contragents', 
                text: 'Контрагенты', 
                link: '/sprav/contragents',
                icon: <IconBookOpenStroked />, 
            },
            {
                itemKey: 'proxy', 
                text: 'Прокси', 
                link: '/sprav/proxy',
                icon: <IconBookOpenStroked />, 
            },
            {
                itemKey: 'ecp', 
                text: 'ЭЦП', 
                link: '/sprav/ecp',
                icon: <IconBookOpenStroked />, 
            }
        ]
    },
    { 
        itemKey: 'reports', 
        text: 'Отчетность', 
        icon: <IconLineChartStroked/>,
        items: [
            {
                itemKey: 'standart',
                text: 'Стандартные отчеты',
                link: '/reports/standart',
                icon: <IconPieChartStroked />
            },
            {
                itemKey: 'reglament', 
                text: 'Регламентированные', 
                link: '/reports/reglament',
                icon: <IconPieChart2Stroked />, 
            },
            {
                itemKey: 'bookprocurement', 
                text: 'Книга покупок', 
                link: '/reports/book/procurement',
                icon: <IconBookStroked />, 
            },
            {
                itemKey: 'booksales', 
                text: 'Книга продаж', 
                link: '/reports/book/sales',
                icon: <IconBookStroked />, 
            }
        ]
    },
    { itemKey: 'edo', text: 'ЭДО', link: '/edo', icon: <IconWindowAdaptionStroked /> },
    { itemKey: 'map', text: 'Карта кластера', link: '/map', icon: <IconFlowChartStroked /> },
    { itemKey: 'sync', text: 'Синхронизация', link: '/sync', icon: <IconLoopTextStroked /> },
    { 
        itemKey: 'bitrix', 
        text: 'Управление Битрикс24', 
        icon: <IconComponentPlaceholderStroked />,
        items: [
            {
                itemKey: 'bitrixnew',
                text: 'Добавить экземпляр',
                link: '/bitrix/new',
                icon: <IconPlusStroked />
            },
            {
                itemKey: 'bitrixleads', 
                text: 'Лиды', 
                link: '/bitrix/leads',
                icon: <IconBarChartVStroked />, 
            },
            {
                itemKey: 'bitrixdeals', 
                text: 'Сделки', 
                link: '/bitrix/deals',
                icon: <IconTestScoreStroked />, 
            },
            {
                itemKey: 'bitrixclients', 
                text: 'Клиенты', 
                link: '/bitrix/clients',
                icon: <IconBarChartVStroked />, 
            },
            {
                itemKey: 'bitrixusers', 
                text: 'Пользователи', 
                link: '/bitrix/users',
                icon: <IconUserListStroked />
            }
        ]
    },
    { 
        itemKey: 'asterisk', 
        text: 'Управление Asterisk', 
        icon: <IconCandlestickChartStroked />,
        items: [
            {
                itemKey: 'asterisksms',
                text: 'Монитор SMS',
                link: '/asterisk/sms',
                icon: <IconSendMsgStroked />
            },
            {
                itemKey: 'asteriskphones', 
                text: 'Номера телефонов', 
                link: '/asterisk/phones',
                icon: <IconSmartphoneStroked />, 
            },
            {
                itemKey: 'asteriskparameters', 
                text: 'Настройки сервиса', 
                link: '/asterisk/settings',
                icon: <IconConfigStroked />
            }
        ]
    },
    { 
        itemKey: 'telegram', 
        text: 'Управление Telegram', 
        icon: <IconGridStroked />,
        items: [
            {
                itemKey: 'telegramosint',
                text: 'OSINT бот',
                link: '/telegram/osint',
                icon: <IconSearch />
            },
            {
                itemKey: 'telegramrasa', 
                text: 'RasaAI бот', 
                link: '/telegram/rasa',
                icon: <IconBulb />, 
            },
            {
                itemKey: 'telegrammain', 
                text: 'Основной бот', 
                link: '/telegram/main',
                icon: <IconBox />, 
            }
        ]
    },
    { 
        itemKey: 'administration', 
        text: 'Управление платформой', 
        icon: <IconSettingStroked />,
        items: [
            {
                itemKey: 'parameters',
                text: 'Параметры системы',
                link: '/admin/parameters',
                icon: <IconConfigStroked />
            },
            {
                itemKey: 'users', 
                text: 'Пользователи', 
                link: '/admin/users',
                icon: <IconUserListStroked />, 
            },
            {
                itemKey: 'requests',
                text: 'Заявки агентов',
                link: '/admin/requests',
                icon: <IconTestScoreStroked />
            },
            {
                itemKey: 'createdb',
                text: 'Новая база данных',
                link: '/admin/createdb',
                icon: <IconPlusStroked />
            },
            {
                itemKey: 'status',
                text: 'Статус сервера',
                link: '/admin/status',
                icon: <IconServerStroked />
            },
            {
                itemKey: 'backups',
                text: 'Резервные копии',
                link: '/admin/backups',
                icon: <IconCloudUploadStroked />
            }   
        ]
    },
    { itemKey: 'documentation', text: `Разработчикам`, link: `${window.location.protocol}//api.${process.env.REACT_APP_HOST}/doc`, icon: <IconCodeStroked /> },
];

class MySidebar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const user_data = this.props.user;
        const loggedIn = this.props.loggedIn;

        return( 
            <Nav
                bodyStyle={{ height: 320 }}
                items={menu}
                onSelect={key => console.log(key)}
                className="verticalMenu"
                header={{
                    logo: <img src={window.location.protocol + "//" + window.location.hostname + "/assets/logo.png"} style={{width: "128px", height: "128px"}} />,
                    text: 
                        <p style={{margin: 0}}>
                            FINANCE CLUB <Tag style={{marginLeft: '5px'}} color="teal" type="ghost">v{config.ui_version}</Tag>
                        </p>
                }}
                footer={
                    <Switch
                        checked={this.props.darkTheme}
                        onChange={this.props.toggleChecked}
                        checkedText="☀️"
                        uncheckedText="🌙"
                        style={{ margin: '0 0 0 auto' }}
                    />
                }
                style={{height: '100%', position: 'relative'}}
            >
                <Divider margin='12px'/>
                <LoginButton
                    behaviour={this.props.behaviour}
                    keycloak={this.props.keycloak}
                    onLoginChange={this.props.onLoginChange}
                />
                {(loggedIn && !isNull(user_data) && (user_data.user.role === "Главный администратор" || user_data.user.role === "Администратор") && user_data.status.statusName === "verified") &&
                    <div className="maintance-container">
                        <MaintanceModeButton />
                    </div>
                }
            </Nav>
        );
    }
};

export default MySidebar;